import { render, staticRenderFns } from "./TrendInsight.vue?vue&type=template&id=692ee940&scoped=true"
import script from "./TrendInsight.vue?vue&type=script&lang=js"
export * from "./TrendInsight.vue?vue&type=script&lang=js"
import style0 from "./TrendInsight.vue?vue&type=style&index=0&id=692ee940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692ee940",
  null
  
)

export default component.exports